module.exports = {"access_token":"27ccb3a0-1ac2-423d-99d6-4dfcfec92a60","url":"https://sms.comtele.com.br","Sender":"47851"}


//////////////////
// WEBPACK FOOTER
// ./static/sms_credentials.json
// module id = dtUv
// module chunks = 1